<template lang='pug'>
//- Consult Chat Message
div(:class='$style[`cc-side-effect-consult-chat`]')
  //- 由醫師 / Dr.Cell 傳送的訊息
  div(v-if='userType === `doctor`' :class='[$style[`cc-side-effect-consult-chat-wrap`], $style[`cc-reverse`]]')
    div(:class='$style[`cc-side-effect-consult-chat-avatar`]')
      figure(v-if='!thumbSrc' :class='$style[`cc-side-effect-consult-chat-img`]')
        img(
          v-if='gender === `0`'
          :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
          width='100%'
          height='100%')
        img(
          v-else
          :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
          width='100%'
          height='100%')
      figure(v-else :class='$style[`cc-side-effect-consult-chat-img`]')
        img(
          :src='avatarSrcLink(thumbSrc)'
          width='100%'
          height='100%')

      div(:class='$style[`cc-side-effect-consult-chat-name`]')
        span.font-regular(:class='$style[`cc-side-effect-consult-chat-name-text`]') {{ firstName + lastName }}
        span.font-regular(:class='$style[`cc-side-effect-consult-chat-character`]') {{ character }}

    div(:class='$style[`cc-side-effect-consult-chat-msg`]')
      //- 文字訊息
      div.font-regular(
        v-if='category === `text`'
        :class='$style[`cc-side-effect-consult-chat-text`]')
        span(:class='$style[`cc-side-effect-consult-chat-text-content`]' v-html='contentRegexMatchURL')

      //- 文字訊息
      div.font-regular(
        v-if='category === `ai-text`'
        :class='[$style[`cc-side-effect-consult-chat-text`], $style[`cc-ai-reply`]]')
        //- span(:class='$style[`cc-side-effect-consult-chat-text-content`]') {{ message }}
        v-md-preview(:text='message')

        div(v-if='extraCourse && extraCourse.length' :class='$style[`cc-side-effect-consult-chat-extra-text`]')
          header.font-bold(:class='$style[`cc-side-effect-consult-chat-extra-text-header`]') 推薦閱讀
          ul
            li(v-for='item, index in extraCourse' :key='index')
              button(
                tabindex='0' :aria-label='`瀏覽${item.title}`'
                @click='handleClickOpenCoursePlayer(item)') {{ item.title }}
                IconSearch(:size='12' :color='`#98a1a1`')

        //- div.font-regular(:class='$style[`cc-side-effect-consult-chat-extra-text-tips`]') 如果您還有疑慮，請點擊下方按鈕請醫師補充說明。

        //- span(:class='$style[`cc-side-effect-consult-chat-text-content`]' v-html='contentRegexMatchURL')
        div(v-if='message !== `很抱歉，我似乎無法完全理解您的問題。`' :class='$style[`cc-side-effect-consult-chat-text-control`]')
          div(:class='$style[`cc-side-effect-consult-chat-text-control-left`]')
            router-link(
              title='更新我的病歷資料'
              tabindex='0' aria-label='更新我的病歷資料'
              :class='$style[`cc-side-effect-consult-chat-text-update-profile`]'
              to='/ecard')
              span 更新病歷

          div(:class='$style[`cc-side-effect-consult-chat-text-control-right`]')
            //- button(
            //-   title='Scroll Top'
            //-   :class='$style[`cc-side-effect-consult-chat-text-evaluate`]'
            //-   tabindex='0' aria-label='滾到這'
            //-   @click='debounceScrollOffsetTop')
            //-   span 滾到這
            template(v-if='evaluateValue')
              button(
                v-if='evaluateValue === `good`'
                title='本回覆有幫助'
                tabindex='0' aria-label='有幫助'
                :class='[$style[`cc-side-effect-consult-chat-text-evaluate`], $style[`cc-evaluate-good`]]'
                @click='debounceSendEvaluate(``)')
                IconThumb(:size='16' :color='`#fff`')

              button(
                v-if='evaluateValue === `bad`'
                title='本回覆沒有幫助'
                tabindex='0' aria-label='沒有幫助'
                :class='[$style[`cc-side-effect-consult-chat-text-evaluate`], $style[`cc-evaluate-bad`]]'
                @click='debounceSendEvaluate(``)')
                IconThumb(:size='16' :color='`#fff`' style='transform: scale(1, -1)')

            template(v-else)
              button(
                title='本回覆有幫助'
                tabindex='0' aria-label='有幫助'
                :class='$style[`cc-side-effect-consult-chat-text-btn`]'
                @click='debounceSendEvaluate(`good`)')
                IconThumb(:size='16' :color='`#81e0a9`')
                span(v-if='rwdType !== `mobile`') 有幫助

              button(
                title='本回覆沒有幫助'
                tabindex='0' aria-label='沒有幫助'
                :class='$style[`cc-side-effect-consult-chat-text-btn`]'
                @click='debounceSendEvaluate(`bad`)')
                IconThumb(:size='16' :color='`#d8374d`' style='transform: scale(1, -1)')
                span(v-if='rwdType !== `mobile`') 沒用

            //- button(
            //-   v-if='raiseHand'
            //-   title='已舉手請醫師補充'
            //-   tabindex='0' aria-label='已舉手請醫師補充'
            //-   :class='$style[`cc-side-effect-consult-chat-text-raised`]'
            //-   @click='handleChooseChatAdditional(false)')
            //-   IconRaiseHand(:size='16' :color='`#fff`')
            //-   span 已舉手

            button(
              v-if='real_reply'
              title='已舉手請醫師補充'
              tabindex='0' aria-label='已舉手請醫師補充'
              :class='$style[`cc-side-effect-consult-chat-text-raised`]'
              disabled)
              IconRaiseHand(:size='16' :color='`#fff`')
              span 已舉手

            button(
              v-else
              title='請醫師補充'
              :class='$style[`cc-side-effect-consult-chat-text-btn`]'
              tabindex='0' aria-label='請醫師補充'
              @click='handleChooseChatAdditional')
              span 請醫師補充

      //- 保健商品
      a(
        v-else-if='category === `stuff` && JSON.parse(message).redirect'
        :href='JSON.parse(message).redirect'
        :class='$style[`cc-side-effect-consult-chat-stuff`]'
        target='_blank'
        tabindex='0' aria-label='查看更多商品')
        div(:class='$style[`cc-side-effect-consult-chat-stuff-left`]')
          header.font-regular 已傳送營養品資訊
          div
            span.font-regular(:class='$style[`cc-side-effect-consult-chat-stuff-left-title`]') {{ JSON.parse(message).title }}
          div
            span(:class='$style[`cc-side-effect-consult-chat-stuff-left-link`]') 查看商品資訊
        figure(:class='$style[`cc-side-effect-consult-chat-stuff-right`]')
          img(
            :src='JSON.parse(message).src'
            width='100%'
            height='100%')

      //- 保健商品
      router-link(
        v-else-if='category === `stuff` && !JSON.parse(message).redirect'
        tag='button'
        :to='`/shop/stuff/${JSON.parse(message).id}`'
        :class='$style[`cc-side-effect-consult-chat-stuff`]'
        tabindex='0' aria-label='查看更多商品')
        div(:class='$style[`cc-side-effect-consult-chat-stuff-left`]')
          header.font-regular 已傳送營養品資訊
          div
            span.font-regular(:class='$style[`cc-side-effect-consult-chat-stuff-left-title`]') {{ JSON.parse(message).title }}
          div
            span(:class='$style[`cc-side-effect-consult-chat-stuff-left-link`]') 查看商品資訊
        figure(:class='$style[`cc-side-effect-consult-chat-stuff-right`]')
          img(
            :src='`${SERVER_STATIC_URL}media/${JSON.parse(message).src}`'
            width='100%'
            height='100%')

      //- 圖片訊息
      button(
        v-else-if='category === `img`'
        tabindex='0' aria-label='點擊放大'
        :class='$style[`cc-side-effect-consult-chat-photo`]'
        @click='handleClickZoomPhoto(`${SERVER_STATIC_URL}media/${message}`)')
        span(:class='$style[`cc-side-effect-consult-chat-zoom`]') 點擊放大
        img(
          :src='`${SERVER_STATIC_URL}media/${message}`'
          width='100%'
          height='100%')

  //- 病患傳送的訊息
  div(v-else-if='userType === `normal`' :class='$style[`cc-side-effect-consult-chat-wrap`]')
    div(:class='$style[`cc-side-effect-consult-chat-msg`]')
      div.font-regular(
        v-if='category === `text`'
        :class='$style[`cc-side-effect-consult-chat-text`]')
        span(:class='$style[`cc-side-effect-consult-chat-text-content`]' v-html='contentRegexMatchURL')

      //- 請求補充說明
      div.font-regular(
        v-if='category === `ai-text`'
        :class='[$style[`cc-side-effect-consult-chat-text`], $style[`cc-ai-reply`]]')
        div(:class='$style[`cc-side-effect-consult-chat-assign-reply`]')
          span(:class='$style[`cc-side-effect-consult-chat-assign-reply-auto`]') 以下AI回覆內容，請求補充說明
          div(:class='$style[`cc-side-effect-consult-chat-assign-reply-block`]')
            header(:class='$style[`cc-side-effect-consult-chat-assign-reply-header`]') 我的提問
            span(:class='$style[`cc-side-effect-consult-chat-assign-reply-text`]') {{ notes }}
          div(:class='$style[`cc-side-effect-consult-chat-assign-reply-block`]')
            header(:class='$style[`cc-side-effect-consult-chat-assign-reply-header`]') Dr.Cell的回覆
            span(:class='$style[`cc-side-effect-consult-chat-assign-reply-text`]') {{ message }}

      button(
        v-else-if='category === `img`'
        tabindex='0' aria-label='點擊放大'
        :class='$style[`cc-side-effect-consult-chat-photo`]'
        @click='handleClickZoomPhoto(`${SERVER_STATIC_URL}media/${message}`)')
        span(:class='$style[`cc-side-effect-consult-chat-zoom`]') 點擊放大
        img(
          :src='`${SERVER_STATIC_URL}media/${message}`'
          width='100%'
          height='100%')



</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconThumb from '../../icon/Thumb';
import IconRaiseHand from '../../icon/RaiseHand';
import IconSearch from '../../icon/Search';

import { debounce } from 'debounce';

import {
  putUpdateChatHistoryList
} from '../../../js/restapi';

export default {
  props: {
    index: null,
    dialog: null,
    message_id: null,
    room: null,
    category: null,
    message: null,
    extra_text: null,
    userType: null,
    gender: null,
    thumbSrc: null,
    firstName: null,
    lastName: null,
    character: null,
    evaluate: null,
    notes: null,
    real_reply: false,
  },

  components: {
    IconThumb,
    IconRaiseHand,
    IconSearch,
  },

  created() {
    if (this.extra_text) {
      this.extraCourse = JSON.parse(this.extra_text);
    }
  },

  data() {
    return {
      preloading: true,
      evaluateValue: this.evaluate || '',
      raiseHand: this.real_reply,
      extraCourse: [],
    };
  },

  methods: {
    ...mapMutations({
      changePopZoomStatus: 'global/POPZOOM_STATUS',
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopCourseStatus: 'global/POPCOURSE_STATUS',
      changePopChatAdditionalStatus: 'global/POPCHAT_ADDITIONAL_STATUS',
    }),

    handleClickZoomPhoto(path) {
      this.changePopZoomStatus({
        active: true,
        src: path
      });
    },

    sendEvaluateForAiReply(value) {
      const CONFIG = {
        message_id: this.message_id,
        room: this.room,
        evaluate: value,
      };

      putUpdateChatHistoryList('', CONFIG)
        .then((res) => {
          this.evaluateValue = value;
        })
        .catch((err) => {
          console.log('err');
        })
    },

    handleChooseChatAdditional() {
      this.changePopChatAdditionalStatus({
        active: true,
        detail: {
          message_id: this.message_id,
          room: this.room,
          message: this.message,
          notes: this.notes,
          extra_text: this.extra_text,
        },
      });
    },

    // handleScrollOffsetTop() {
    //   console.log('handleScrollOffsetTop', this.dialog, this.index);
    //   this.$emit('scrollToMessage', {
    //     dialog: this.dialog,
    //     index: this.index
    //   });
    // },

    // debounceScrollOffsetTop: debounce(async function(e) {
    //   this.handleScrollOffsetTop(e);
    // }, 300),

    handleClickOpenCoursePlayer: debounce(async function(e) {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
        return;
      };

      this.changePopCourseStatus({
        active: true,
        cid: Number(e.course_id),
        uid: e.id,
      });
    }, 300),

    // debounceRaiseHand: debounce(async function(e) {
    //   // this.sendWaitForDoctorReply(e);
    //   this.handleChooseChatAdditional(e);
    // }, 300),

    debounceSendEvaluate: debounce(async function(e) {
      this.sendEvaluateForAiReply(e);
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginStatus: 'user/exportLoginStatus',
    }),

    contentRegexMatchURL: function() {
      // let newContent = this.msgContent.content;
      let newContent = this.message;
      console.log('computed', this.message);
      const urlRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/g;
      const matchURL = newContent.match(urlRegex);
      if (matchURL) {
        newContent = newContent.replace(urlRegex, `<a href="${matchURL[0]}" target="_blank">${matchURL[0]}</a>`);
      }
      return newContent;
    }
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/EffectChatRoomMsg.scss';
</style>
